import React from 'react';
import VideoTextPair from './VideoTextPair';
import {
  beforeYourBookingDescription,
  bookingAndPricingDescription,
  duringYourBookingDescription,
  endingYourBookingDescription,
  maximizingEarningsDescription,
  signUpDescription,
  thumbnail1,
  thumbnail2,
  thumbnail3,
  thumbnail4,
  thumbnail5,
  thumbnail6,
  signup,
  bookingPricing,
  beforeBooking,
  duringBooking,
  earning,
  endBooking
} from './utils';

const MiddleColumn = ({ cityCode }) => {
  return (
    <div className="outer-container">
      <div className="middle-container">
        <div className="video-text" style={{ color: '#414141' }}>
          How it works?
        </div>
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/signing_up.mp4'
          }
          videoTitle={'Sign up'}
          videoDescription={signUpDescription}
          thumbnail={thumbnail1}
          caption={signup}
        />
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/booking.mp4'
          }
          videoTitle={'Booking and Pricing'}
          videoDescription={bookingAndPricingDescription}
          thumbnail={thumbnail2}
          caption={bookingPricing}
        />
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/before_your_booking.mp4'
          }
          videoTitle={'Before Your Booking'}
          videoDescription={beforeYourBookingDescription}
          thumbnail={thumbnail3}
          caption={beforeBooking}
        />
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/during_your_booking.mp4'
          }
          videoTitle={'During Your Booking'}
          videoDescription={duringYourBookingDescription}
          thumbnail={thumbnail4}
          caption={duringBooking}
        />
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/maximizing_earnings.mp4'
          }
          videoTitle={'Maximizing Earnings'}
          videoDescription={maximizingEarningsDescription}
          thumbnail={thumbnail5}
          caption={earning}
        />
        <VideoTextPair
          videoSrc={
            'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/ending_your_booking.mp4'
          }
          videoTitle={'Ending Your Booking'}
          videoDescription={endingYourBookingDescription}
          thumbnail={thumbnail6}
          caption={endBooking}
        />
        <div className="question-text">
          <span className="description-text">
            If you have any questions, please view our{' '}
            <a
              href={`https://autzu.com/${cityCode}/faq`}
              className="link-in-video">
              FAQ
            </a>{' '}
            or{' '}
            <a
              href={`https://autzu.com/${cityCode}/contact`}
              className="link-in-video">
              Contact us
            </a>
            .
          </span>
        </div>
      </div>
    </div>
  );
};

export default MiddleColumn;



// WEBPACK FOOTER //
// ./src/components/Videos/MiddleColumn.js